export default class Welcome {
  userId!: string
  profileText?: string
  welcomeText?: string
}
